import React from 'react';
import { Outlet } from 'react-router-dom';
import { ServiceClassificationProvider } from '../../../contexts/ServiceClassificationContext';

function ClasificacionServiciosLayout() {
  return (
    <ServiceClassificationProvider>
      <Outlet />
    </ServiceClassificationProvider>
  );
}

export default ClasificacionServiciosLayout;
